import { render, staticRenderFns } from "./BlockMarketplace.vue?vue&type=template&id=68e1acd6&scoped=true"
import script from "./BlockMarketplace.vue?vue&type=script&lang=js"
export * from "./BlockMarketplace.vue?vue&type=script&lang=js"
import style0 from "./BlockMarketplace.vue?vue&type=style&index=0&id=68e1acd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e1acd6",
  null
  
)

export default component.exports